import { useCallback } from 'react'
import PropTypes from 'prop-types'

import Chat from 'features/chat/webchat/Chat'
import { getDirectLineAnonymous } from './functions'
import { createDirectLine } from 'botframework-webchat'

const ChatAnonymous = ({
  isAnonymous,
  urlConfig,
  displayInnerHeader = false,
  chatbotName,
  headerFollowupText,
  hideUploadButton = false,
  hideNewConversationButton = false,
  botAvatar,
  soundUrl,
  forceAutoscrollOnNewMessage,
  isDevelopment,
  headerChatVersion,
  emojiSet,
  sessionId,
  refreshTokenTimeout
}) => {
  const displayUserName = ''

  const handleConnectToDirectline = useCallback(
    ({ fullTokenUrl, getNewConversation, setDirectLine }) => {
      const executeFetch = async () => {
        const directlineToken = await getDirectLineAnonymous(getNewConversation, fullTokenUrl, sessionId)
        const { token } = directlineToken
        const directline = createDirectLine({ token })
        setDirectLine(directline)
      }
      executeFetch()
    },
    [sessionId]
  )

  const handleReconnectToDirectline = useCallback(
    ({ fullTokenUrl, getNewConversation, directLine, setDirectLine }) => {
      if (sessionId) {
        const executeFetch = async () => {
          const directlineToken = await getDirectLineAnonymous(getNewConversation, fullTokenUrl, sessionId)
          const { token, streamUrl, conversationId } = directlineToken
          if (directLine) {
            directLine.reconnect({
              token,
              streamUrl,
              conversationId
            })
          } else {
            const directline = createDirectLine({ token })
            setDirectLine(directline)
          }
        }
        executeFetch()
      }
    },
    [sessionId]
  )

  return (
    <div id='tswebchat_container'>
      <Chat
        handleConnectToDirectline={handleConnectToDirectline}
        handleReconnectToDirectline={handleReconnectToDirectline}
        isAnonymous={isAnonymous}
        urlConfig={urlConfig}
        displayInnerHeader={displayInnerHeader}
        chatbotName={chatbotName}
        displayUserName={displayUserName}
        headerFollowupText={headerFollowupText}
        hideUploadButton={hideUploadButton}
        hideNewConversationButton={hideNewConversationButton}
        botAvatar={botAvatar}
        soundUrl={soundUrl}
        forceAutoscrollOnNewMessage={forceAutoscrollOnNewMessage}
        isDevelopment={isDevelopment}
        headerChatVersion={headerChatVersion}
        emojiSet={emojiSet}
        refreshTokenTimeout={refreshTokenTimeout}
      />
    </div>
  )
}

ChatAnonymous.propTypes = {
  isAnonymous: PropTypes.bool.isRequired,
  urlConfig: PropTypes.object.isRequired,
  displayInnerHeader: PropTypes.bool,
  chatbotName: PropTypes.object.isRequired,
  headerFollowupText: PropTypes.object.isRequired,
  hideUploadButton: PropTypes.bool,
  hideNewConversationButton: PropTypes.bool,
  botAvatar: PropTypes.object,
  soundUrl: PropTypes.string,
  forceAutoscrollOnNewMessage: PropTypes.bool,
  isDevelopment: PropTypes.bool,
  headerChatVersion: PropTypes.string,
  emojiSet: PropTypes.bool || PropTypes.object,
  sessionId: PropTypes.string,
  refreshTokenTimeout: PropTypes.number
}

export default ChatAnonymous
